import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/plat/sec/';

const baseApi = () => {
    function applyTicket(data) {
        return Post(baseUrl + 'ticket/apply', data, {
            headers: {
                Type: `primary_time_${new Date().getTime()}`
            }
        });
    }

    return {
        applyTicket
    };
};

export const securityApi = baseApi();
